import { useMutation, useQueryClient } from 'react-query'
import { message } from 'antd'
import { postJSON } from 'common/services/api'
import { UpdateProcedureInput, Procedure } from '../types'

interface UseProcedureUpdateReturn {
  updateProcedure: (input: UpdateProcedureInput) => Promise<Procedure>
  isUpdating: boolean
}

export const useProcedureUpdate = (
  residentId: string,
  onSuccess?: () => void
): UseProcedureUpdateReturn => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async (input: UpdateProcedureInput) => {
      const { _id, ...updateData } = input

      const response = await postJSON({
        url: `/api/list/procedures/${_id}`,
        method: 'PUT',
        json: updateData
      })

      return response as Procedure
    },
    {
      onSuccess: () => {
        message.success('Procedure updated successfully')
        // Invalidate procedures list to refetch
        queryClient.invalidateQueries(['procedures', residentId])
        if (onSuccess) {
          onSuccess()
        }
      },
      onError: (error: any) => {
        message.error(error?.message || 'Failed to update procedure')
      }
    }
  )

  const updateProcedure = async (
    input: UpdateProcedureInput
  ): Promise<Procedure> => {
    return mutation.mutateAsync(input)
  }

  return {
    updateProcedure,
    isUpdating: mutation.isLoading
  }
}
